import React from 'react';

import { connect } from 'react-redux';
import QR from 'qrcode.react';
// import QRCode from 'qrcode.react';
import Cookies from 'js-cookie';

import colors from '../util/colors';
import { VERSION } from './utils';

// Actions
import { deleteDevice } from '../store/actions/deviceActions';
import { clearFeaturedPlaylist, clearUserPlaylists, clearActivePlaylist } from '../store/actions/playlistActions';
import { clearUser } from '../store/actions/userActions';
import { clearSubscription } from '../store/actions/subscriptionActions';
import { DELETE_DEVICE_SUCCESS } from '../store/constants/deviceConstants';

import { LEFT, RIGHT, BACK, ENTER, EXIT } from '../util/remoteButtons';

export class Account extends React.Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.selectedBtn = 'None';
    this.selectedBtn1 === 'No';

    this.state = {
      open: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      const { backButton } = this.refs;
      backButton.focus();
      this.selectedBtn = 'Back';      
    }, 300);
    // window.history.pushState("backhandler", null, null);
  }

  handleKeyDown(e) {
    e.stopPropagation();
    e.preventDefault();
    switch (e.which) {
      case RIGHT:
        if (this.selectedBtn === 'Back') {
          this.refs.logout.focus();
          this.selectedBtn = 'Logout';
        }
        break;
      case LEFT:
        if (this.selectedBtn === 'Logout') {
          this.refs.backButton.focus();
          this.selectedBtn = 'Back';
        }
        break;
      case ENTER:
        console.log("History State Account Page : ", window.history);
        if (this.selectedBtn === 'Back') {
          // window.history.go(-1);
          this.props.history.goBack();
        }
        if (this.selectedBtn === 'Logout') {
          this.logout();
        }
        break;
      case 27: // ///////////////For Esc Keyboard Key
      case BACK:
        console.log("History State Account Page : ", this.props.history);
        // if (window.history.state !== "backhandler") {
          // window.history.pushState("backhandler", null, null);
        // } else {
          this.props.history.goBack();
        // }
        break;
    }
  }

  logout = async () => {
    try {
      const response = await this.props.deleteDevice(this.props.device.data.id);
      this.props.clearFeaturedPlaylist();
      this.props.clearUserPlaylists();
      this.props.clearActivePlaylist();
      this.props.clearUser();
      this.props.clearSubscription();
      Cookies.remove('auth__token');
      if (response.errors === 'Error') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      }
      if (response.type === DELETE_DEVICE_SUCCESS) {
        this.props.history.push('/');
      }
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    return (
      <div className="UpgradeWrapper">
        <div className="qrCodeWrapper">
          <div className="content-wrapper">
            <div className="text-wrapper">
              PAIR WITH SMARTPHONE
            </div>
            <div className="scan-text-wrapper">
              Scan the below QR code using the smartphone app to pair your display
            </div>
          </div>
          <div className="qr-wrapper">
            <QR className="QRCode" value={this.props.app.FireTVDeviceId} size={300} renderAs="svg" />
            <img className="img-wrapper" src="/assets/img/blackdovelogo.png" alt="" />
          </div>
        </div>
        <div className="downloadButtonWrapper" onKeyDown={this.handleKeyDown}>
          <img className="downloadImg-wrapper" src="/assets/img/TV.png" alt="" />
          <img className="iphone-wrapper" src="/assets/img/iPhone.png" alt="" />
          <div className="info-Content-Wrapper">
            <div className="art-wrapper">
              ACCOUNT
            </div>
            <div className="download-art-wrapper" style={{fontSize:'24px'}}>
              <strong>Account:</strong> {this.props.user.data.user?.email}<br/>
              <strong>Subscription:</strong> {this.props.subscription.data.plan?.name}<br/>
              <div style={{marginTop:'16px', fontSize:'18px'}}>Go to https://account.blackdove.com to change your account details and edit your subscription.</div>
            </div>
          </div>
          <div className="button-Wrapper" style={{top:'80%', padding:'3%'}}>
          <button id="back" ref="backButton" className="connect-wrapper-infodiv-contentdisplay-buttonWrapper-backbtn" onClick={() => this.props.history.goBack()}>Close</button>
          <button id="logout" ref="logout" className="connect-wrapper-infodiv-contentdisplay-buttonWrapper-logoutbtn" onClick={() => this.logout()}>Logout</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  deleteDevice: (deviceId) => dispatch(deleteDevice(deviceId)),
  clearFeaturedPlaylist: () => dispatch(clearFeaturedPlaylist()),
  clearUserPlaylists: () => dispatch(clearUserPlaylists()),
  clearActivePlaylist: () => dispatch(clearActivePlaylist()),
  clearUser: () => dispatch(clearUser()),
  clearSubscription: () => dispatch(clearSubscription()),
});

export default connect((state) => {
  const { app, activePlaylist, device, user, subscription } = state;
  return {
    app,
    device,
    user,
    subscription,
    activePlaylist,
  };
}, mapDispatchToProps)(Account);
